import React, { useEffect, useState, useContext, useRef } from 'react'
import {
  // CNav,
  // CNavItem,
  // CNavLink,
  CTabContent,
  CTabPane,
  CRow,
  CCard,
  CButton,
  CFormSelect,
  CFormInput,
} from '@coreui/react'
import SearchTable from 'src/components/searchTable'
import { ANALYTICS_API } from 'src/views/utils/urls'
import useAxios from 'axios-hooks'
import { AppContext } from 'src/views/context/app'
import getSymbolFromCurrency from 'currency-symbol-map'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

const ContentPartnerAnalytics = () => {
  const { setLoader, accountObj } = useContext(AppContext)
  const dateRangeRef = useRef(null)
  // const [activePane, setActivePane] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [currencyFilter, setCurrencyFilter] = useState('')
  const [selectedCurrency, setSelectedCurrency] = useState('')
  const [currencyData, setCurrencyData] = useState([])
  const [revenueShareData, setRevenueShareData] = useState([])
  const [filterRevenueShareData, setFilterRevenueShareData] = useState([])
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [totalData, setTotalData] = useState({
    totalPPVRevenue: 0,
    totalSubscriptionRevenue: 0,
  })

  const [{ data: contentPartnerData, loading: contentPartnerDataLoading }, contentPartnerCall] =
    useAxios(
      {
        url: `${ANALYTICS_API}/content-partner-revenue-analytics`,
        method: 'get',
      },
      { manual: true },
    )

  const [{ loading: downloadExcelLoading, response: downloadExcelResponse }, downloadExcelCall] =
    useAxios(
      {
        url: `${ANALYTICS_API}/content-partner-revenue-analytics/download`,
        method: 'get',
        responseType: 'arraybuffer',
      },
      { manual: true },
    )

  useEffect(() => {
    if (!isEmpty(accountObj)) {
      setCurrencyFilter(accountObj?.allowed_countries[0]?.currency)
      setSelectedCurrency(accountObj?.allowed_countries[0]?.currency)
      setCurrencyData(accountObj?.allowed_countries)
      contentPartnerCall({
        params: {
          currency: accountObj?.allowed_countries[0]?.currency,
        },
      })
    }
  }, [accountObj])

  useEffect(() => {
    if (contentPartnerData && contentPartnerData.success) {
      setSelectedCurrency(currencyFilter)
      let data = contentPartnerData?.data
      setRevenueShareData(data.revenue_share_data)
      setFilterRevenueShareData(data.revenue_share_data)
      setTotalData({
        totalPPVRevenue: Number(data.total_ppv_revenue).toFixed(2),
        totalSubscriptionRevenue: Number(data.total_subscription_revenue).toFixed(2),
      })
    }
  }, [contentPartnerData])

  useEffect(() => {
    if (downloadExcelResponse && downloadExcelResponse.status === 200) {
      const blob = new Blob([downloadExcelResponse.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `content-partner-report.xlsx`
      link.click()
    }
  }, [downloadExcelResponse])

  useEffect(() => {
    setLoader(contentPartnerDataLoading || downloadExcelLoading)
  }, [contentPartnerDataLoading, downloadExcelLoading])

  const applyFilter = () => {
    contentPartnerCall({
      params: {
        start_date: startDate,
        end_date: endDate,
        currency: currencyFilter,
      },
    })
  }

  const downloadExcel = () => {
    downloadExcelCall({
      params: {
        start_date: startDate,
        end_date: endDate,
        currency: selectedCurrency,
      },
    })
  }

  const resetFilters = () => {
    if (dateRangeRef.current) {
      dateRangeRef.current.$picker[0].value = ''
    }
    setStartDate('')
    setEndDate('')
    setCurrencyFilter(currencyData[0]?.currency)
    contentPartnerCall({
      params: {
        currency: currencyData[0]?.currency,
      },
    })
  }

  const handleDateChange = (event, picker) => {
    picker.element.val(
      picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'),
    )
    setStartDate(moment.utc(picker.startDate).format('YYYY-MM-DDTHH:mm:ss'))
    setEndDate(moment.utc(picker.endDate).format('YYYY-MM-DDTHH:mm:ss'))
  }

  const handleCancel = (event, picker) => {
    picker.element.val('')
    setStartDate('')
    setEndDate('')
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 17,
    },
    {
      header: 'Email',
      dataCell: (info) => info.email_id,
      width: 24,
    },
    {
      header: 'PPV Share',
      dataCell: (info) =>
        `${Number(info.ppv_share).toFixed(2)}${
          selectedCurrency ? getSymbolFromCurrency(selectedCurrency) : ''
        }`,
      width: 18,
    },
    {
      header: 'Subscription Share',
      dataCell: (info) =>
        `${Number(info.subscription_share).toFixed(2)}${
          selectedCurrency ? getSymbolFromCurrency(selectedCurrency) : ''
        }`,
      width: 18,
    },
    {
      header: 'Total Payout',
      dataCell: (info) =>
        `${Number(info.total_payout).toFixed(2)}${
          selectedCurrency ? getSymbolFromCurrency(selectedCurrency) : ''
        }`,
      width: 18,
    },
  ]

  // const activeTab = { color: '#1976d2', fontSize: '1.1rem', cursor: 'pointer' }
  // const inActiveTab = { color: '#191818', fontSize: '1.1rem', cursor: 'pointer' }

  useEffect(() => {
    if (searchText) {
      handleSearch()
    } else {
      setFilterRevenueShareData(revenueShareData)
    }
  }, [searchText])

  const handleClearSearch = () => {
    setSearchText('')
    setFilterRevenueShareData(revenueShareData)
  }
  const handleSearch = () => {
    setFilterRevenueShareData(
      revenueShareData.filter((info) => {
        console.log(info.name.toLowerCase().includes(searchText.toLowerCase()))
        if (
          info.name.toLowerCase().includes(searchText.toLowerCase()) ||
          info.email_id.toLowerCase().includes(searchText.toLowerCase())
        ) {
          return true
        }
        return false
      }),
    )
  }
  return (
    <div className="">
      <h2>Content Partner Analytics</h2>
      <CRow className="mt-3">
        {/* <CNav variant="tabs">
          <CNavItem>
            <CNavLink
              className="px-5"
              style={activePane === 1 ? activeTab : inActiveTab}
              active={activePane === 1}
              onClick={() => setActivePane(1)}
            >
              {`Content Partner`}
            </CNavLink>
          </CNavItem>
        </CNav> */}
        <CTabContent>
          <CTabPane role="tabpanel" visible={true}>
            <CRow>
              <CCard>
                <div className="d-flex justify-content-between mt-3 py-2">
                  <div className="d-flex">
                    <p className="mt-1">Filters:</p>
                    <div className="mx-2">
                      <CFormSelect
                        size="sm"
                        placeholder="Status"
                        value={currencyFilter}
                        onChange={(e) => setCurrencyFilter(e.target.value)}
                      >
                        <option value="" selected disabled>
                          Currency
                        </option>
                        {currencyData.map((info, index) => (
                          <option value={info.currency} key={index}>
                            {info.currency}
                          </option>
                        ))}
                      </CFormSelect>
                    </div>
                    <div className="mx-3">
                      <DateRangePicker
                        ref={dateRangeRef}
                        initialSettings={{
                          autoUpdateInput: false,
                          locale: { format: 'DD/MM/YYYY', cancelLabel: 'Clear' },
                          placeholder: 'Select Date Range',
                        }}
                        onApply={handleDateChange}
                        onCancel={handleCancel}
                      >
                        <CFormInput
                          size="sm"
                          type="text"
                          className=""
                          defaultValue=""
                          placeholder="Select Date Range"
                        />
                      </DateRangePicker>
                    </div>
                    <div className="mx-2">
                      <CButton color="info" size="sm" className="text-white" onClick={applyFilter}>
                        Apply
                      </CButton>
                    </div>
                    <p
                      className="mt-1"
                      style={{ color: '#1976d2', cursor: 'pointer' }}
                      onClick={resetFilters}
                    >
                      Reset Filter
                    </p>
                  </div>
                  <div className="d-flex">
                    <div className="mx-2">
                      <CButton
                        color="success"
                        size="sm"
                        className="text-white"
                        onClick={downloadExcel}
                      >
                        Download Excel
                      </CButton>
                    </div>
                  </div>
                </div>
                <div className=" d-flex justify-content-between">
                  <div className="content-partner-analytics-info d-flex align-items-center">
                    <div
                      className="text-center font-weight-bold border py-1"
                      style={{ width: '23%', fontWeight: 'bold' }}
                    >
                      Total PPV Revenue :
                    </div>
                    <div className=" text-center border py-1" style={{ width: '25%' }}>
                      {`${totalData.totalPPVRevenue} ${
                        selectedCurrency ? getSymbolFromCurrency(selectedCurrency) : ''
                      }`}
                    </div>
                    <div
                      className="font-weight-bold text-center border py-1"
                      style={{ width: '27%', fontWeight: 'bold' }}
                    >
                      Total Subscription Revenue :
                    </div>
                    <div className=" text-center border py-1" style={{ width: '25%' }}>
                      {`${totalData.totalSubscriptionRevenue} ${
                        selectedCurrency ? getSymbolFromCurrency(selectedCurrency) : ''
                      }`}
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center position-relative">
                    <CFormInput
                      type="text"
                      // style={{ width: '18rem' }}
                      placeholder="Search..."
                      size="sm"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                    {searchText && (
                      <FontAwesomeIcon
                        className="position-absolute"
                        style={{ cursor: 'pointer', right: '5px' }}
                        icon={faTimes}
                        title="clear"
                        onClick={handleClearSearch}
                      />
                    )}
                  </div>
                </div>
                <div style={{ zIndex: '0' }}>
                  <SearchTable
                    type={`Content Partner Report`}
                    tableCardHeight={63}
                    disableButton={true}
                    disableSearch={true}
                    marginDisable={true}
                    textAlign={'center'}
                    tableContent={filterRevenueShareData}
                    tableConfig={tableConfig}
                  />
                </div>
              </CCard>
            </CRow>
          </CTabPane>
        </CTabContent>
      </CRow>
    </div>
  )
}

export default ContentPartnerAnalytics
